import { styled, Typography } from '@mui/material';

export const HeatmapWrapper = styled('div')(({ theme, width, height }) => ({
  width     : width || '174px',
  height    : height || '174px',
  '& > div' : {},
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  fontWeight : '700',
}));

export const Container = styled('div')(({ theme }) => ({
  display        : 'flex',
  flexDirection  : 'column',
  justifyContent : 'center',
  alignItems     : 'center',
  '& >div'       : {
    flex : '1',
  },
}));

export const Legend = styled('div')({
  width    : '90%',
  '& >div' : {
    display                 : 'flex',
    justifyContent          : 'space-between',
    alignItems              : 'center',
    '& >div:nth-of-type(2)' : {
      color : '#909090',
    },
  },
});

export const RangeBar = styled('div')(({ theme }) => ({
  width        : '100%',
  height       : '24px',
  background   : 'linear-gradient(90deg, #9CD4EE 0%, #2D5786 100%);',
  borderRadius : '1px',
  marginBottom : '16px',
}));
